import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || '/';

const api = axios.create({
  baseURL: `${API_BASE_URL}/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Request interceptor - attach token and language
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('farmdirectly_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Attach session ID for guest cart
    const sessionId = localStorage.getItem('farmdirectly_session');
    if (sessionId) {
      config.headers['x-session-id'] = sessionId;
    }
    // Attach language for localized responses
    const lang = localStorage.getItem('farmdirectly_lang');
    if (lang && lang !== 'en') {
      config.params = { ...config.params, lang };
    }
    // Let Axios auto-set Content-Type for FormData (multipart/form-data with boundary)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('farmdirectly_token');
      // Optionally redirect to login
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
